export default __webpack_public_path__ + "static/media/donation_white.f8ff8d7f.svg";